export default "__VITE_ASSET__DKZh21XC__"